import { createIcon } from "@chakra-ui/icons";

// Created from add.svg

export const AddIcon = createIcon({
  displayName: "Add",
  viewBox: "0 0 94 94",
  path: (
    <g>
      <path
        d="M74.4167 11.75H19.5833C15.2571 11.75 11.75 15.2571 11.75 19.5833V74.4167C11.75 78.7429 15.2571 82.25 19.5833 82.25H74.4167C78.7429 82.25 82.25 78.7429 82.25 74.4167V19.5833C82.25 15.2571 78.7429 11.75 74.4167 11.75Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="4"
      />
      <path
        d="M47 31.3334V62.6667"
        stroke="currentColor"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.3335 47H62.6668"
        stroke="currentColor"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});
